import { defineComponent as _defineComponent } from 'vue'
import { useAsyncState } from '@vueuse/core';
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import DashboardService from '@/services/DashboardService';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';

type MissingItem = 'SUMMARY' | 'SKILLS' | 'EXPERIENCES' | 'AVATAR'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionApplyProfileCheck',
  setup(__props) {

const { t } = useI18n();

const { state: profileStatus } = useAsyncState(() => DashboardService.getUserProfileStatus(), null);

const list = computed(() => {
  const items:MissingItem[] = [];

  if (profileStatus.value?.missingImage) items.push('AVATAR');
  if (profileStatus.value?.missingSummary) items.push('SUMMARY');
  if (profileStatus.value?.missingSkills) items.push('SKILLS');
  if (profileStatus.value?.missingExperiences) items.push('EXPERIENCES');

  return items.map(
    (item) => `- **${t(`project-forum.apply-box.profile-check-items.${item}`)}**`
  ).join('\n');
});

return { __sfc: true,t, profileStatus, list, MarvinInfoBox }
}

})